module.exports = __webpack_public_path__ + "static/media/arrow-right-white@3x.d068602d.png";